import { PedagogyUtils, ReactIcons } from "@kalyzee/escaet-ui";
import { MeetingOrderedSession } from "@kalyzee/kast-web-sdk";
import { MeetingSession } from "@kalyzee/kast-web-sdk/websocket";
import { useReducedAlerts } from "../../hooks/meeting";

export interface BadBehaviorsCounterProps {
  sessions?: (MeetingSession | MeetingOrderedSession)[];
  style?: React.CSSProperties;
}

export const BadBehaviorsCounter: React.FC<BadBehaviorsCounterProps> = ({
  sessions,
  style,
}) => {
  const alerts = useReducedAlerts(sessions);
  
  if (alerts.camera === 0 && alerts.network === 0 && alerts.attention === 0) {
    return (
      <div style={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "white",
        borderRadius: 999,
        padding: 4,
        gap: "0.5em",
        paddingRight: "1em",
        fontWeight: 800,
        fontSize: 12,
        height: 50,
        ...(style || {}),
      }}>
        <div style={{
          backgroundColor: "#05C49626",
          borderRadius: "50%",
          padding: 10,
        }}>
          <div style={{
            backgroundColor: "#05C496",
            width: 20,
            height: 20,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
            <ReactIcons.CheckMark style={{ color: "white", width: 10 }} /> 
          </div>
        </div>
        Aucun comportement inapproprié détecté
      </div>
    )
  }
  
  return (
    <div style={{
      display: "flex",
      flexDirection: "row",
      gap: "0.5em",
      height: 50,
      alignItems: "center",
      ...(style || {}),
    }}>
      <PedagogyUtils.BadBehaviorTags.NoCamera 
        text={`${alerts.camera}`}
        active
      />
      <PedagogyUtils.BadBehaviorTags.BadNetwork 
        text={`${alerts.network}`}
        active
      />
      <PedagogyUtils.BadBehaviorTags.NotAttentive 
        text={`${alerts.attention}`}
        active
      />
    </div>
  );
};